import { el } from 'redom';

import { easepick } from '@easepick/core';

import application from 'application';

import internalEventCodes from 'event-system/codes/internal';

import {
  findIndexByPropertyValue
} from 'utilities/collection';

import TextInputBox from 'generics/components/text-input/text-input-box';
import TextAreaBox from 'generics/components/text-input/text-area-box';
import SaveButton from 'generics/components/save-button';

import ProfilePictureDisplay from 'root/startup-view/inbox/profile-picture-display';

import './index.scss';

class MemberCalendar {

  constructor(configuration) {

    this.picker = null;
    this.facade = configuration.facade;
    this.memberId = configuration.memberId;
    this.profilePictureDisplay = new ProfilePictureDisplay();
    this.memberName = el('h3.calendar-member-name');
    this.calendarTarget = el('.calendar-target');
    this.calendarContainer = el('.calendar-container', [this.calendarTarget]);
    this.emailInputBox = new TextInputBox({
      placeholder: 'Enter email',
      disabled: true
    });
    this.notesInputBox = new TextAreaBox({
      placeholder: 'Notes',
      disabled: true
    });
    this.saveButton = new SaveButton({
      label: 'Create Appointment',
      disabled: true
    });

    this.el = el('.member-calendar-main', [
      this.profilePictureDisplay,
      this.memberName,
      this.calendarContainer,
      this.emailInputBox,
      this.notesInputBox,
      this.saveButton
    ]);

  }

  displayMemberCalendar(member) {

    this.profilePictureDisplay.update(member);
    this.memberName.textContent = member.fullName;

    this.picker = new easepick.create({
      element: this.calendarTarget,
      css: [
        'https://cdn.venturz.co/lib/@easepick/1.2.1.css'
      ],
      zIndex: 1,
      grid: 1,
      inline: true
    });

    this.facade.showMemberCalendar();

  }

  async tryDisplayMemberCalendar() {

    if (this.picker !== null) {
      this.picker.destroy();
    }

    const members = await application.startupModule.members.loadMembers();

    const index = findIndexByPropertyValue(members, '_id', this.memberId);

    if (index === -1) {
      application.eventSystem.internal.emit(internalEventCodes.DISPLAY_SYSTEM_TOAST_MESSAGE, {
        message: 'Member does not exists!',
        seconds: 5,
        type: 'error'
      });
      this.facade.hideMemberCalendar();
      return;
    }

    this.displayMemberCalendar(members[index]);

  }

  setMemberId(memberId) {

    this.memberId = memberId;

    this.tryDisplayMemberCalendar();

  }

  onmount() {

    this.tryDisplayMemberCalendar();

  }

  onunmount() {

    this.picker?.destroy();

  }

}

export default MemberCalendar;